import { createContext, useContext } from 'react';
import type { SocialRewardController } from './useSocialReward';

/**
 * Один контроллер подарка на приложение (ТЗ главной § 11): его держит `SocialRewardProvider` в
 * оболочке вместе с единственным диалогом. Два вызова `useSocialReward` дали бы два диалога, и
 * колбэк VK (`/?social_reward=…`) обработался бы дважды.
 */
export const SocialRewardContext = createContext<SocialRewardController | null>(null);

/** Контроллер из оболочки; вне провайдера — null (подарок там просто не предлагается). */
export function useSocialRewardController(): SocialRewardController | null {
  return useContext(SocialRewardContext);
}

/**
 * Что предложить в боковой панели и в строке создания: `locked` — подарок можно получить,
 * `ready` — пополнение сохранено и ждёт; null — не показывать (выключен или 404, статус
 * недоступен или с ошибкой, использован или скрыт). Ошибку и «спасибо» показывает «Сообщество».
 */
export function giftOffer(reward: SocialRewardController): 'locked' | 'ready' | null {
  const { data, isError } = reward.statusQuery;
  if (!data?.enabled || isError || reward.cardHidden) return null;
  if (data.rewardStatus === 'available') return 'ready';
  if (data.rewardStatus === 'locked') return 'locked';
  return null;
}
